import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class ClienteService {
    public sessionInfo = JSON.parse(StorageService.getSession());
    public ciaId = this.sessionInfo.id_cia;
    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) { }



    insertCliente(cliente: any) {
        this.apiService.setUrlPathApi("cliente/");
        return this.apiService.executePostJson(cliente).pipe();
    }

    actualizarCliente(cliente: any) {
        this.apiService.setUrlPathApi("cliente/");
        return this.apiService.executePutJson(cliente).pipe();
    }

    eliminar(codcli: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codcli}`);
    }


    // clases

    buscarClasesObligatotias(): Observable<any> {
        this.apiService.setUrlPathApi("cliente/clases-obligatorias");
        return this.apiService.execGetJson();
    }

    buscarClases(): Observable<any> {
        this.apiService.setUrlPathApi("cliente/clases");
        return this.apiService.execGetJson();
    }

    buscarCodigos(clase: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/clases/${clase}/codigos`);
        return this.apiService.execGetJson();
    }

    buscarUbigeos(coddepart: any) {
        this.apiService.setUrlPathApi(`cliente/clases/ubigeo`);
        return this.apiService.execGetQueryJson(`?coddepart=${coddepart}`);
    }

    eliminarClase(codcli: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codcli}/clases/${clase}`);
    }

    eliminar_codpag(codcli: any, codpag: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codcli}/condicion-pago/${codpag}`);
    }

    eliminar_contacto(codcli: any, codcont: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codcli}/contactos/${codcont}`);
    }
    eliminar_especificacion(codcli: any, codesp: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codcli}/especificaciones/${codesp}`);
    }
    eliminar_direcciones_envio(codcli: any, codenv: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codcli}/direcciones-envio/${codenv}`);
    }
    eliminar_clase_direcciones_envio(codcli: any, codenv: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codcli}/direcciones-envio/${codenv}/clase/${clase}`);
    }

    eliminar_bancos(codcli: any, codefi: any, tipcta: any, moneda: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.executeDeleteJson(`${codcli}/bancos/${codefi}/tipo-cuenta/${tipcta}/moneda/${moneda}`);
    }
    insertar_bancos(codcli: any, clienteBanco: any): Observable<any> {
        this.apiService.setUrlPathApi(`cliente/${codcli}/bancos`);
        return this.apiService.executePostJson(clienteBanco).pipe();
    }
    actualizar_bancos(codcli: any, clienteBanco: any) {
        this.apiService.setUrlPathApi(`cliente/${codcli}/bancos`);
        return this.apiService.executePutJson(clienteBanco).pipe();
    }

    saldo_disponible(codcli: any) {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.execGetQueryJson(`${codcli}/saldo-disponible`);
    }

    /*************************UBIGEO*********************************/

    get_direcciones_envio_clases_codigos(clase: any) {
        this.apiService.setUrlPathApi(`cliente/`);
        return this.apiService.execGetQueryJson(`direcciones-envio/clases/${clase}/codigos`);
    }

    get_direcciones_envio_clases_ubigeo(coddepart: any) {
        this.apiService.setUrlPathApi(`cliente/direcciones-envio/clases/ubigeo`);
        return this.apiService.execGetQueryJson(`?coddepart=${coddepart}`);
    }
    /****** Documento Adjuntos***************** */
    insertarAdjuntoCliente(data: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto`);
        return this.apiService.executePostJson(data).pipe();
    }

    actualizarAdjuntoCliente(data: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto`);
        return this.apiService.executePutJson(data).pipe();
    }

    deleteAdjuntoCliente(codcli: any, tipcli: any, id: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto`);
        return this.apiService.executeDeleteJson(`/${id}?tipcli=${tipcli}&codcli=${codcli}`)
    }

    obtenerAdjuntoCliente(codcli: any, tipcli: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto/buscar`);
        return this.apiService.execGetQueryJson(`?tipcli=${tipcli}&codcli=${codcli}`)
    }

    descargarAdjuntoCliente(codcli: any, tipcli: any, id: any): Observable<any> {
        this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/interlocutor-adjunto/descargar/` + id);
        return this.apiService.execGetQueryJsonPDF(`?tipcli=${tipcli}&codcli=${codcli}`).pipe();
    }
}